import { apiRequest } from "../apiRequest";

const addReferral = (data) => {
  return apiRequest("/referral/add", "POST", data);
};

export default addReferral;
